import plug from './img/plug_icon.svg'
import avatar from './img/Avatar.svg'
import customHeaders, { getSpace } from '../../common/headers';
import StarIcon from '@mui/icons-material/Star'
import info_icon from './img/info_icon.svg'
import edit_icon from './img/edit_icon.svg'
import brand_icon from './img/brand_icon.svg'
import no_data_icon from './img/no_data_icon.svg'
import category_icon from './img/category_icon.svg'
import { Link } from 'react-router-dom';
import { Rating } from '@mui/material';
import { MoonLoader } from 'react-spinners';
import { SendMessage } from '../SendMessage/SendMessage';
import { TabsGreyBtn } from '../TabsGreyBtn/TabsGreyBtn';
import { InputDynamicWidth } from "@lk-gtcom/ecomlab-components";
import { useEffect, useState, useRef } from 'react';
import { ButtonBasic, NoDataContent, Sceleton } from "@lk-gtcom/ecomlab-components";
import { ButtonsSort } from '../Buttons/BurronsSort/ButtonsSort';
import { KonstantinFeedbackHttps, KonstantinMasterHttps } from '../../fetchUrls';
import useGeneralStore from '../../store/general';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { msToLocalDate } from '../../common/constant';
import InfiniteScroll from "react-infinite-scroll-component";
import { ProductInfoPanel } from './Productinfopanel/Productinfopanel';
import ImageViewer from '../ImageViewer/ImageViewer';
import './ChatReview.scss'

export const getFormatedDate = (date, format = 'date') => {
    switch (format) {
        case 'date-2dgt':
            return `${new Date(date)?.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' })}`
        case 'date':
            return `${new Date(date)?.toLocaleDateString('ru-RU')}`
        case 'fullDate':
            return `${new Date(date)?.toLocaleDateString('ru-RU')} ${new Date(date)?.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}`
        case 'time':
            return `${new Date(date)?.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}`
    }
}

export const CardMessageChat = ({
    data,
    currentMessage,
    setCurrentMessage,
    setCurrentShop,
    setCurrentMessageProduct,
    setCurrentMpId,
    setCurrentImg,
    setDate,
    setRating,
    status
}) => {

    const {
        primary_image, created_at, product_name, link, product_valuation, store_name, feedback_text, answer_text, photo_links,
        category_name, brand_name, id, api_id, mp_id
    } = data


    return <div className={currentMessage == id ? 'message_active' : 'message'}
        key={JSON.stringify(data)}
        onClick={(e) => {
            setRating(product_valuation)
            setCurrentMessage(id)
            setCurrentShop(api_id)
            setCurrentMessageProduct([product_name, link])
            setCurrentImg(primary_image)
            setDate(created_at)
            setCurrentMpId(mp_id)
        }}
    >
        <div className='icon-container'>
            <img src={primary_image} onError={e => e.target.src = plug} loading='lazy' />
            <div className={answer_text ? 'answered' : 'not-answered'}>{answer_text ? 'Отвечен' : 'Не отвечен'}</div>
        </div>
        <div className='info-content'>
            <h3 className='title'>{product_name ? product_name : 'Нет названия'}</h3>

            <div className='category-name'>
                <img src={category_icon} className='icon' />
                <p className='text'>{category_name ? category_name : 'Нет названия'}</p>
            </div>

            <div className='brand-name'>
                <img src={brand_icon} className='icon' />
                <p className='text'>{brand_name ? brand_name : 'Нет названия'}</p>
            </div>

            <p className='text_feedback'>
                {feedback_text}
            </p>

            {status == 'Модерация' && <div className='message__card-moderation'>На модерации
            </div>}
        </div>
        <div className='rating-and-date'>
            {product_valuation &&
                <div className='rating-color-box'>
                    <Rating
                        precision={1}
                        defaultValue={product_valuation}
                        max={1}
                        readOnly
                        emptyIcon={<StarIcon style={{ opacity: '.1' }} />}
                        icon={<StarIcon style={{ fill: '#faaf00' }} />}
                        size="large" />
                    <p className='text_rating'>{product_valuation}</p>
                </div>
            }

            {
                created_at &&
                <p className='text_date'>{getFormatedDate(created_at, 'date')} <span>{getFormatedDate(created_at, 'time')}</span></p>
            }
        </div>
    </div>

}

export const ChatMessage = ({
    message_id,
    data,
    created_at,
    setIsEdit,
    setAnswer,
    is_read,
    date }) => {

    return (
        <div className='message-item' style={{ marginLeft: 'auto' }}>
            <div className='message-and-icon'>
                <div className='message-user' key={message_id}>
                    <p className='text'>{data ? data : 'Ответ отсутствует'}</p>
                    {created_at && <p className='date_create'>{getFormatedDate(created_at)}</p>}
                </div>
                <div className='img-box'>
                    <img src={avatar} />
                </div>
            </div>
            <div className='info-box' style={{ marginLeft: 'auto', marginRight: '48px' }}>
                <button className='btn-edit'
                    onClick={(e) => {
                        setAnswer(data)
                        setIsEdit(true)
                    }}
                >Редактировать <img src={edit_icon} /></button>
                <p className='date'>Ответ продавца</p>
            </div>
        </div>
    )
}

export const UserMessage = ({
    message_id,
    data,
    created_at,
    is_read,
    rating,
    path,
    currentImg,
    author,
    images
}) => {

    const [curImg, setCurImg] = useState(null)
    const [isModal, setIsModal] = useState(false)

    return (
        <>
            <ImageViewer
                isOpen={isModal}
                images={curImg}
                onClose={(e) => setIsModal(false)}
            />

            <div className='message-item  message-item-user'>
                <div className='message-and-icon'>
                    <div className='img-box'>
                        <img src={currentImg ? currentImg : avatar} style={{ objectFit: 'contain' }} />
                    </div>
                    <div className='message-support' key={message_id}>
                        <p className='text'>
                            {data ? data : `Поставлена оценка: `}
                            {!data && rating &&
                                <div className='rating-content'> {rating}
                                    <Rating
                                        precision={1}
                                        defaultValue={rating}
                                        max={1}
                                        readOnly
                                        emptyIcon={<StarIcon style={{ opacity: '.1' }} />}
                                        icon={<StarIcon style={{ fill: '#faaf00' }} />}
                                        size="small" />
                                </div>
                            }
                        </p>
                        <div className='bottom-content'>
                            {data && <div className='rating-content'> {rating}
                                <Rating
                                    precision={1}
                                    defaultValue={rating}
                                    max={1}
                                    readOnly
                                    emptyIcon={<StarIcon style={{ opacity: '.1' }} />}
                                    icon={<StarIcon style={{ fill: '#faaf00' }} />}
                                    size="small" />
                            </div>}
                            {created_at && <p className='date_create'>{getFormatedDate(created_at)}</p>}
                        </div>

                    </div>
                </div>
                {images?.length > 0 &&
                    <div className='img-group'>
                        {images?.map(({ miniSize, fullSize }, ind) =>
                            <div
                                className='img-box clickable'
                                key={ind}
                                onClick={() => {
                                    setCurImg(miniSize)
                                    setIsModal(true)
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <img
                                    src={miniSize ? miniSize : plug}
                                    alt={`Изображение ${ind + 1}`}
                                />
                            </div>
                        )}
                    </div>
                }

                <div className='info-box'>
                    <p className='date'>{`Отзыв от ${author ? author : 'Неизвестный автор'}`}</p>
                </div>

            </div>
        </>
    )
}


const ChatReview = ({ ...props }) => {
    const {
        btns,
        path,
        pageValue,
        isSearchLastPage = false,
        resetHeight,
        setResetHeight,
        status,
        setStatus,
        tableBody,
        _date,
        selectedMarketplace,
        allPeriod,
        isCheckWithText,
        selectedApi,
        selectedBrand,
        selectedCategory,
        selectedRating,
    } = props
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    // Проверка страницы
    const is_answer = pageValue == 'feedbacks'
    const btn_sort = [
        { label: 'Дата', value: 'Дата' },
        ...is_answer ? [{ label: 'Оценка', value: 'Оценка' }] : []
    ]

    const [fetchedData, setFetchedData] = useState([])
    const [total, setTotal] = useState(0)

    const [currentSort, setCurrentSort] = useState(null)
    const [sortBtn, setSortBtn] = useState(null)

    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)

    const [currentImg, setCurrentImg] = useState([])
    const [currentMessage, setCurrentMessage] = useState()
    const [currentShop, setCurrentShop] = useState()
    const [currentMessageProduct, setCurrentMessageProduct] = useState([])

    const [isLoadingMessage, setIsLoadingMessage] = useState(false)
    const [chatMessages, setChatMessages] = useState([])

    const [chatInfo, setChatInfo] = useState({})
    const [currentMpId, setCurrentMpId] = useState(-1)
    const [rating, setRating] = useState()
    const [date, setDate] = useState('')
    const [answerValue, setAnswerValue] = useState('')
    const [answer, setAnswer] = useState('')
    const [searchInput, setSearchInput] = useState('')
    const [author, setAuthor] = useState('')
    const [isEdit, setIsEdit] = useState(false)

    const [productGlobalInfo, setProductGlobalInfo] = useState({})

    const listRef = useRef()

    const [isShowInformation, setIsShowInformation] = useState(false)

    const fetchChatList = (abortController = new AbortController()) => {

        setLoading(true)
        let url = `${KonstantinMasterHttps}/wb/${path}/chat-list?with_text=${isCheckWithText}${sortBtn ? '&order_param=' + currentSort?.value + '&order_param_direction=' + sortBtn : ''}`

        let product_valuation_list;
        const [date_from, date_to] = _date;

        if (selectedRating?.length > 0) {
            product_valuation_list = selectedRating?.map((el) => el.value);
        }

        const body = JSON.stringify({
            filters: [],
            search_param: searchInput,
            limit: 10,
            status,
            page,
            date_from: allPeriod ? null : msToLocalDate(date_from),
            date_to: allPeriod ? null : msToLocalDate(date_to),
            api_id_list: getValueMultiFilter(selectedApi),
            mp_id_list: getValueMultiFilter(selectedMarketplace),
            brand_id_list: getValueMultiFilter(selectedBrand),
            category_id_list: getValueMultiFilter(selectedCategory),
            product_valuation_list
        })

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(({ items, total }) => {
                if (page > 1) {
                    setFetchedData(prev => {
                        const updated = [...prev, ...items]
                        setHasMore(updated.length < total)
                        return updated
                    })
                } else {
                    setFetchedData([...items])
                    setHasMore(items.length < total)
                }
                setTotal(total)
            })
            .catch(err => console.error(err))
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })

    }

    const fetchChat = () => {
        let url = `${KonstantinMasterHttps}/wb/${path}/chat?api_id=${currentShop}&mp_id=${currentMpId}&${path === 'feedbacks' ? 'feedback_id' : 'question_id'}=${currentMessage}`

        setIsLoadingMessage(true)
        fetch(url, { method: 'GET', headers })
            .then(res => res.json())
            .then(json => {
                const { api_id, chat_id, customer_name, messages, opened } = json
                if (messages) setChatMessages(messages)
                setAuthor(customer_name)
                setChatInfo({ api_id, id: chat_id, name: customer_name, opened })
                setAnswerValue('')
                setIsEdit(false)
            })
            .catch(err => console.error(err))
            .finally(() => setIsLoadingMessage(false))
    }

    const fetchChatInfo = () => {
        let url = `${KonstantinMasterHttps}/wb/${path}/chat/product-info`

        const chat_id = path === 'feedbacks' ? { feedback_id: currentMessage } : { question_id: currentMessage }
        const [date_from, date_to] = _date

        const body = JSON.stringify({
            api_id: currentShop,
            mp_id: currentMpId,
            date_from: allPeriod ? null : msToLocalDate(date_from),
            date_to: allPeriod ? null : msToLocalDate(date_to),
            ...chat_id
        })

        fetch(url, { body, method: 'POST', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(json => {
                setProductGlobalInfo(json)
                setIsShowInformation(true)
            })
            .catch(err => {
                setProductGlobalInfo({ error: true })
                console.error(err)
            })
    }

    const fetchAnswer = () => {
        // setLoading(true)

        if (answerValue) {
            let url = `${KonstantinFeedbackHttps}/${path}/answer`

            const messageId = path === 'feedbacks' ? { feedback_id: currentMessage } : { question_id: currentMessage }

            const body = JSON.stringify({
                mp_id: currentMpId,
                api_id: currentShop,
                text: answerValue,
                ...messageId,
            })

            fetch(url, { body, method: 'POST', headers })
                .then(res => console.log(res.json()))
                .catch(err => {
                    console.error(err)
                })
                .finally(() => setLoading(false))
        }

    }

    const messageTypeChecker = (message, path) => {
        const { message_id, user_type, images } = message

        return (
            user_type === 'seller' ?
                <ChatMessage
                    setIsEdit={(e) => setIsEdit(e)}
                    setAnswer={(e) => setAnswer(e)}
                    key={message_id}
                    {...message}
                    date={date} />
                :
                <UserMessage
                    author={author}
                    rating={rating}
                    key={message_id}
                    currentImg={currentImg}
                    {...message}
                    path={path ? path : false} />
        )
    }

    useEffect(() => {
        setDate(null)
        setRating(null)
        setIsEdit(false)
        setCurrentImg([])
        setFetchedData([])
        setAnswerValue('')
        setChatMessages([])
        setCurrentShop(null)
        setCurrentMpId(null)
        setCurrentMessage(null)
        setCurrentMessageProduct([])
        setIsShowInformation(false)

        setSortBtn(null)
        setCurrentSort(null)
    }, [pageValue, path, status]);

    // Сброс пагинации при сортировке
    useEffect(() => {
        setFetchedData([])
        setHasMore(true)
        setPage(1)
    }, [sortBtn, currentSort])

    useEffect(() => {
        const abortController = new AbortController()
        fetchChatList(abortController)
        return () => abortController.abort()
    }, [
        tableBody,
        pageValue,
        page,
        searchInput,
        isCheckWithText,
        status,
        sortBtn,
        currentSort
    ])

    useEffect(() => {
        if (currentMessage) {
            fetchChat()
            if (isShowInformation) {
                fetchChatInfo()
            }
        }
    }, [currentMessage])

    useEffect(() => {
        if (listRef.current) {
            if (resetHeight) {
                listRef.current.scrollTop = 0
                setPage(1)
                setHasMore(true)
                setResetHeight(false)
            }
        }
    }, [fetchedData, isSearchLastPage, resetHeight])

    return (
        <div className='tabs-and-chat'>
            <TabsGreyBtn
                btns={btns}
                currentBtn={status}
                setCurrentBtn={(e) => setStatus(e)}
                checkValue={true}
            />

            <div className='chat-review'>
                <div className='chat-review__content'>
                    <div className='chat-review__left-content'>

                        <header className='chat-review__header'>
                            <ButtonsSort
                                currentSort={currentSort}
                                setCurrentSort={setCurrentSort}
                                btnSort={btn_sort}
                                sort={sortBtn}
                                setSort={setSortBtn}
                            />

                            <InputDynamicWidth
                                //  isFeedback
                                position='left'
                                maxWidth='100%'
                                drop={false}
                                value={searchInput}
                                onChange={setSearchInput}
                            />
                        </header>
                        <div className='list-message'>
                            <div
                                className='list-message__content'
                                ref={listRef}
                                id="reviewScrollableDiv"
                                style={{ overflowY: 'auto', height: '100%' }}
                            >
                                {loading && !fetchedData.length
                                    ?
                                    [...Array(5)].map((el, ind) => {
                                        return <Sceleton
                                            width={'100%'}
                                            height={'146px'}
                                            key={ind}
                                        />
                                    })
                                    :
                                    <>
                                        <InfiniteScroll
                                            scrollableTarget="reviewScrollableDiv"
                                            dataLength={fetchedData?.length}
                                            next={() => {
                                                if (!loading && hasMore) {
                                                    setPage(prev => prev + 1)
                                                }
                                            }}
                                            hasMore={hasMore}
                                            loader={loading &&
                                                <div className='list-message__loader'>
                                                    <MoonLoader
                                                        size={40}
                                                        color="#7b7b7b"
                                                        speedMultiplier={0.5}
                                                    />
                                                </div>
                                            }
                                        >
                                            {
                                                fetchedData?.map((el) => {
                                                    return <CardMessageChat
                                                        status={status}
                                                        key={JSON.stringify(el)}
                                                        data={el}
                                                        path={path}
                                                        currentMessage={currentMessage}
                                                        setCurrentMessage={(e) => setCurrentMessage(e)}
                                                        setCurrentMpId={e => setCurrentMpId(e)}
                                                        setCurrentShop={(e) => setCurrentShop(e)}
                                                        setCurrentMessageProduct={(e) => setCurrentMessageProduct(e)}
                                                        setCurrentImg={(e) => setCurrentImg(e)}
                                                        setDate={(e) => setDate(e)}
                                                        setRating={(e) => setRating(e)}
                                                    />
                                                })
                                            }
                                        </InfiniteScroll>
                                        {
                                            fetchedData?.length < 1 &&
                                            < NoDataContent
                                                height='100%'
                                                border={false}
                                                img={no_data_icon}
                                                description={`Здесь пока ничего нет`}
                                            />
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>

                    <div className='chat-review__right-content'>
                        <div className='chat'>

                            <div className='chat__header'>
                                <div className='title-and-rating'>
                                    <Link className='title_product'
                                        onClick={e => window.open(currentMessageProduct?.[1], '_blank')}>
                                        {currentMessageProduct?.[0]}
                                    </Link>

                                    {rating && <div className='rating-and-date'>
                                        <div className='rating-color-box'>
                                            <Rating
                                                precision={1}
                                                defaultValue={rating}
                                                max={1}
                                                readOnly
                                                emptyIcon={<StarIcon style={{ opacity: '.1' }} />}
                                                icon={<StarIcon style={{ fill: '#faaf00' }} />}
                                                size="large" />
                                            <p className='text_rating'>{rating}</p>
                                        </div>
                                    </div>}
                                </div>

                                <div className='bottom-info'>
                                    {date && <p className='text_date'>{getFormatedDate(date, 'date')}
                                        <span> {getFormatedDate(date, 'time')}</span>
                                    </p>}
                                    {currentMessageProduct?.[0] && <button className='btn-info'
                                        onClick={(e) => {
                                            fetchChatInfo()
                                        }}
                                    ><img src={info_icon} />Подробнее о товаре</button>}
                                </div>
                            </div>

                            <div className='chat__content'>
                                {!isLoadingMessage ? (chatMessages.length ?
                                    chatMessages.map((el, ind) => messageTypeChecker(el, rating, author, date, currentImg, path))
                                    :
                                    < NoDataContent
                                        height='100%'
                                        border={false}
                                        img={no_data_icon}
                                        description={`Выберите товар, чтобы увидеть ${is_answer ? 'отзывы' : 'вопросы'}`}
                                    />
                                ) :
                                    <div className='chat__loader'>
                                        <MoonLoader
                                            size={40}
                                            color="#7b7b7b"
                                            speedMultiplier={0.5}
                                        />
                                    </div>
                                }
                            </div>

                            <SendMessage
                                frequentAnswers
                                isEdit={isEdit}
                                setIsEdit={(e) => setIsEdit(e)}
                                disabled={!chatInfo?.opened}
                                message={answer}
                                value={answerValue}
                                btn={status == 'Модерация' ? <ButtonBasic
                                    grey
                                    width='auto'
                                    text='Cохранить на модерации'
                                /> : null}
                                actionBtnText={status == 'Модерация' ? 'Подтвердить' : 'Отправить'}
                                onChange={e => setAnswerValue(e)}
                                onSendAction={e => fetchAnswer()} />
                        </div>
                    </div>
                </div>

                <ProductInfoPanel
                    isShowInformation={isShowInformation}
                    setIsShowInformation={setIsShowInformation}
                    productGlobalInfo={productGlobalInfo}
                />
            </div>
        </div>
    )
}

export { ChatReview }
